import type {
  ChannelAudienceResponse,
  ChannelBroadcastDto,
  ChannelBroadcastListResponse,
  ChannelBroadcastRequest,
  ChannelInboxConversation,
  ChannelInboxResponse,
  ChannelThreadResponse,
} from '@pulsify/shared'
import { api, unwrap } from '~/shared/lib/rpc'

export const channelAdminApi = {
  async audience(city?: string): Promise<number> {
    const res = await api.api.channel.admin.audience.$get({ query: city ? { city } : {} })
    return (await unwrap<ChannelAudienceResponse>(res)).count
  },

  async list(): Promise<ChannelBroadcastDto[]> {
    const res = await api.api.channel.admin.broadcasts.$get()
    return (await unwrap<ChannelBroadcastListResponse>(res)).broadcasts
  },

  async send(input: ChannelBroadcastRequest): Promise<ChannelBroadcastDto> {
    const res = await api.api.channel.admin.broadcasts.$post({ json: input })
    return await unwrap<ChannelBroadcastDto>(res)
  },

  async inbox(): Promise<ChannelInboxConversation[]> {
    const res = await api.api.channel.admin.inbox.$get()
    return (await unwrap<ChannelInboxResponse>(res)).conversations
  },

  async thread(conversationId: string): Promise<ChannelThreadResponse> {
    const res = await api.api.channel.admin.inbox[':id'].messages.$get({
      param: { id: conversationId },
    })
    return await unwrap<ChannelThreadResponse>(res)
  },

  async reply(conversationId: string, message: string): Promise<{ id: string }> {
    const res = await api.api.channel.admin.inbox[':id'].messages.$post({
      param: { id: conversationId },
      json: { message },
    })
    return await unwrap<{ id: string }>(res)
  },
}
